var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "mt-5 mb-5" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12 text-right" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-light",
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.signOutPartner.apply(null, arguments)
                }
              }
            },
            [
              _c("i", { staticClass: "fas fa-power-off" }),
              _vm._v(" ออกจากระบบ")
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row mt-3" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("div", { staticClass: "card" }, [
            _c("h5", { staticClass: "card-header" }, [
              _c("span", [_vm._v("รายงานการให้บริการ Grab")]),
              _vm._v(" "),
              _vm.partner
                ? _c("img", {
                    staticClass: "img-fluid float-right",
                    attrs: { src: _vm.partner.picture, alt: "", width: "100" }
                  })
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card-body" }, [
              _c(
                "form",
                {
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.searchOrderWithStat.apply(null, arguments)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-4" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "" } }, [
                          _vm._v("กำหนดช่วงเวลา")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-check" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.searchParams.type_date,
                                expression: "searchParams.type_date"
                              }
                            ],
                            staticClass: "form-check-input",
                            attrs: {
                              type: "radio",
                              required: "",
                              name: "type_date",
                              id: "type_date1",
                              value: "order_date"
                            },
                            domProps: {
                              checked: _vm._q(
                                _vm.searchParams.type_date,
                                "order_date"
                              )
                            },
                            on: {
                              change: function($event) {
                                return _vm.$set(
                                  _vm.searchParams,
                                  "type_date",
                                  "order_date"
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "form-check-label",
                              attrs: { for: "type_date1" }
                            },
                            [
                              _vm._v(
                                "\n                        วันที่ทำการจอง\n                      "
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-check" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.searchParams.type_date,
                                expression: "searchParams.type_date"
                              }
                            ],
                            staticClass: "form-check-input",
                            attrs: {
                              type: "radio",
                              name: "type_date",
                              id: "type_date2",
                              value: "cleaning_date"
                            },
                            domProps: {
                              checked: _vm._q(
                                _vm.searchParams.type_date,
                                "cleaning_date"
                              )
                            },
                            on: {
                              change: function($event) {
                                return _vm.$set(
                                  _vm.searchParams,
                                  "type_date",
                                  "cleaning_date"
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "form-check-label",
                              attrs: { for: "type_date2" }
                            },
                            [
                              _vm._v(
                                "\n                        วันที่ใช้บริการ\n                      "
                              )
                            ]
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-8" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-6" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", { attrs: { for: "startDate" } }, [
                              _vm._v("วันที่เริ่มต้น")
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              class: {
                                "form-control": true,
                                "-date-picker": true,
                                "is-invalid": _vm.errors.has("startDate")
                              },
                              attrs: {
                                type: "text",
                                id: "startDate",
                                name: "startDate",
                                readonly: "",
                                placeholder: "วันที่เริ่มต้น",
                                "data-vv-as": "วันที่เริ่มต้น"
                              },
                              on: {
                                change: function($event) {
                                  return _vm.updateDate("start_date", $event)
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has("startDate"),
                                    expression: "errors.has('startDate')"
                                  }
                                ],
                                staticClass: "help text-danger"
                              },
                              [_vm._v(_vm._s(_vm.errors.first("startDate")))]
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-6" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", { attrs: { for: "endDate" } }, [
                              _vm._v("วันที่สิ้นสุด")
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              class: {
                                "form-control": true,
                                "-date-picker": true,
                                "is-invalid": _vm.errors.has("endDate")
                              },
                              attrs: {
                                type: "text",
                                id: "endDate",
                                name: "endDate",
                                "data-vv-as": "วันที่สิ้นสุด",
                                readonly: "",
                                placeholder: "วันที่สิ้นสุด"
                              },
                              on: {
                                change: function($event) {
                                  return _vm.updateDate("end_date", $event)
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has("endDate"),
                                    expression: "errors.has('endDate')"
                                  }
                                ],
                                staticClass: "help text-danger"
                              },
                              [_vm._v(_vm._s(_vm.errors.first("endDate")))]
                            )
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-success",
                          attrs: { type: "submit" }
                        },
                        [_vm._v("ค้นหา")]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-light ml-3",
                          attrs: { type: "button" },
                          on: { click: _vm.clearValue }
                        },
                        [_vm._v("ล้างค่า")]
                      )
                    ])
                  ])
                ]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("div", { staticClass: "card" }, [
            _c("h5", { staticClass: "card-header" }, [_vm._v("สถิติทั่วไป")]),
            _vm._v(" "),
            _c("div", { staticClass: "card-body" }, [
              _c("div", { staticClass: "table-responsive" }, [
                _c("table", { staticClass: "table" }, [
                  _c("tbody", [
                    _c("tr", [
                      _c("td", [
                        _vm._v("จำนวนการจองทั้งหมด (Total Bookings):")
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            _vm.partnerGrabData
                              ? _vm.partnerGrabData.total_bookings
                              : ""
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [
                        _vm._v(
                          "จำนวนการจองที่มีคุณแม่บ้านรับงาน (Allocated Bookings):"
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            _vm.partnerGrabData
                              ? _vm.partnerGrabData.allocated_bookings
                              : ""
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [
                        _vm._v(
                          "จำนวนงานที่ให้บริการแล้วเสร็จ (Completed Bookings):"
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            _vm.partnerGrabData
                              ? _vm.partnerGrabData.completed_bookings
                              : ""
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [
                        _vm._v(
                          "จำนวนเคสที่มีปัญหาการให้บริการ (Reported Case):"
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            _vm.partnerGrabData
                              ? _vm.partnerGrabData.reported_case
                              : ""
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [
                        _vm._v(
                          "เฉลี่ยระยะเวลารอคุณแม่บ้านรับงาน (AVG lead time for booking allocation):"
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            _vm.partnerGrabData
                              ? _vm.partnerGrabData.avg_time_allocation_orders +
                                  " นาที"
                              : ""
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [
                        _vm._v(
                          "จำนวนงานที่ไม่มีคุณแม่บ้านรับงาน (Unallocated bookings):"
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            _vm.partnerGrabData
                              ? _vm.partnerGrabData.unallocated_bookings
                              : ""
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [
                        _vm._v(
                          "จำนวนเคสที่มีการถูกยกเลิก (PAX cancelled bookings):"
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            _vm.partnerGrabData
                              ? _vm.partnerGrabData.cancel_bookings
                              : ""
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [
                        _vm._v(
                          "% AR งานที่มีคุณแม่บ้านรับงาน (AR = allocated bookings / total bookings):"
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            _vm.partnerGrabData
                              ? _vm.partnerGrabData
                                  .percentage_allocatated_booking + "%"
                              : ""
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [
                        _vm._v(
                          "% FR งานเสร็จสิ้น (FR = completed bookings / total bookings):"
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            _vm.partnerGrabData
                              ? _vm.partnerGrabData
                                  .percentage_completed_booking + "%"
                              : ""
                          )
                        )
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-body" }, [
              _c(
                "form",
                {
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.searchOrder.apply(null, arguments)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-6" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "" } }, [
                          _vm._v("เงื่อนไขการค้นหาอื่น:")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.searchParams.keyword,
                              expression: "searchParams.keyword"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            required: "",
                            placeholder:
                              "Booking ID/ Reference ID/ เบอร์โทร/ Email คุณลูกค้า"
                          },
                          domProps: { value: _vm.searchParams.keyword },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.searchParams,
                                "keyword",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-6" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c(
                          "label",
                          { staticClass: "mr-3", attrs: { for: "" } },
                          [_vm._v("เรียงข้อมูล:")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-check form-check-inline" },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.searchParams.order_by,
                                  expression: "searchParams.order_by"
                                }
                              ],
                              staticClass: "form-check-input",
                              attrs: {
                                type: "radio",
                                name: "order_by",
                                id: "order_by1",
                                value: "asc"
                              },
                              domProps: {
                                checked: _vm._q(
                                  _vm.searchParams.order_by,
                                  "asc"
                                )
                              },
                              on: {
                                change: function($event) {
                                  return _vm.$set(
                                    _vm.searchParams,
                                    "order_by",
                                    "asc"
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "form-check-label",
                                attrs: { for: "order_by1" }
                              },
                              [_vm._v("น้อยไปมาก")]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-check form-check-inline" },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.searchParams.order_by,
                                  expression: "searchParams.order_by"
                                }
                              ],
                              staticClass: "form-check-input",
                              attrs: {
                                type: "radio",
                                name: "order_by",
                                id: "order_by2",
                                value: "desc"
                              },
                              domProps: {
                                checked: _vm._q(
                                  _vm.searchParams.order_by,
                                  "desc"
                                )
                              },
                              on: {
                                change: function($event) {
                                  return _vm.$set(
                                    _vm.searchParams,
                                    "order_by",
                                    "desc"
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "form-check-label",
                                attrs: { for: "order_by2" }
                              },
                              [_vm._v("มากไปน้อย")]
                            )
                          ]
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-success",
                          attrs: { type: "submit" }
                        },
                        [_vm._v("ค้นหา")]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-light ml-3",
                          attrs: { type: "button" },
                          on: { click: _vm.searchAndClearValue }
                        },
                        [_vm._v("รีเซ็ท\n                  ")]
                      )
                    ])
                  ])
                ]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-12 text-right" },
          [
            !_vm.partnerGrabData ||
            !_vm.partnerGrabData.bookings ||
            _vm.partnerGrabData.bookings.length < 0
              ? [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-success btn-sm",
                      attrs: { disabled: "" }
                    },
                    [_vm._v("EXPORT")]
                  )
                ]
              : [
                  _c(
                    "a",
                    {
                      staticClass: "btn btn-success btn-sm",
                      attrs: { href: _vm.exportReport, target: "_blank" }
                    },
                    [_vm._v("EXPORT")]
                  )
                ]
          ],
          2
        )
      ]),
      _vm._v(" "),
      _vm.partnerGrabData &&
      _vm.partnerGrabData.bookings &&
      _vm.partnerGrabData.bookings.length > 0
        ? _c("div", { staticClass: "row mt-3" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "table-responsive" }, [
                _c("table", { staticClass: "table" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    [
                      _vm._l(_vm.partnerGrabData.bookings, function(
                        item,
                        index
                      ) {
                        return _c("tr", { key: index }, [
                          _c("td", { staticClass: "text-center" }, [
                            _vm._v(_vm._s(index + 1))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-center" }, [
                            _vm._v(_vm._s(item.order_code))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-center" }, [
                            _vm._v(
                              _vm._s(
                                item.partner_order_commission
                                  ? item.partner_order_commission.reference
                                  : ""
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-center" }, [
                            _vm._v(
                              _vm._s(_vm._f("prettyDate")(item.order_date))
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-center" }, [
                            _vm._v(_vm._s(item.name))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-center" }, [
                            _vm._v(_vm._s(item.address))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-center" }, [
                            _vm._v(
                              _vm._s(
                                _vm.diffDurationTime(
                                  item.order_date,
                                  item.confirm_cleaning_date,
                                  true
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "text-center" },
                            [
                              item.cancel > 0
                                ? [
                                    _c("span", { staticClass: "text-danger" }, [
                                      _vm._v("งานถูกยกเลิิก")
                                    ])
                                  ]
                                : [
                                    item.status === 0
                                      ? _c(
                                          "span",
                                          { staticClass: "text-warning" },
                                          [
                                            _vm._v(
                                              "\n                ยังไม่มีคุณแม่บ้านรับงาน\n              "
                                            )
                                          ]
                                        )
                                      : item.status === 1
                                      ? _c(
                                          "span",
                                          { staticClass: "text-info" },
                                          [
                                            _vm._v(
                                              "\n                มีคุณแม่บ้านรับงานแล้ว\n              "
                                            )
                                          ]
                                        )
                                      : item.status === 2
                                      ? _c(
                                          "span",
                                          { staticClass: "text-success" },
                                          [
                                            _vm._v(
                                              "\n                ให้บริการเสร็จแล้ว\n              "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                            ],
                            2
                          )
                        ])
                      }),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", { attrs: { colspan: "6" } }),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "text-center",
                            staticStyle: { "border-top": "1px solid black" }
                          },
                          [
                            _vm._v(
                              "เฉลี่ย = " + _vm._s(_vm.convertAvgHour) + " ชม."
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-center" })
                      ])
                    ],
                    2
                  )
                ])
              ])
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "text-center" }, [_vm._v("#")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("Booking ID")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("Reference ID")]),
        _vm._v(" "),
        _c(
          "th",
          { staticClass: "text-center", staticStyle: { width: "15%" } },
          [_vm._v("วันที่ทำรายการ")]
        ),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("ชื่อคุณลูกค้า")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("ชื่อสถานที่")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [
          _vm._v("ระยะเวลาที่คุณแม่บ้านรับงาน (ชม.)")
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("สถานะการให้บริการ")])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14e98d5c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14e98d5c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/partner/BookingGrabReport.vue
// module id = 2363
// module chunks = 0